import { LanguageData,PriorityData,RelationData,DoctorDetailsData,MedicalRequestDataModel,UserProfileModel,ManadatoryFieldsDataModel} from "../../Model/index";

export class MedicalRequestDataContainer {
    PriorityDataList: PriorityData[] = [];
	RelationDataList: RelationData[] = [];
	DoctorDataList: DoctorDetailsData[] = [];
	LanguageDataList: LanguageData[] = [];
	MedicalRequestDataModelList: MedicalRequestDataModel[] = [];
	userprofile: UserProfileModel = new UserProfileModel();	
	MandatoryFieldList: ManadatoryFieldsDataModel[] = [];
    sessionExpiry: boolean;
    SessionTimeout: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/MedicalRequest/MedicalRequestDataContainer.ts